export default {
  components: {
    locationSelector: {
      labelKey: 'cmp-bus-directory-map-sub-title-key-location',
      inputItem: {
        placeholder: 'cmp-bus-directory-map-select-state',
      },
    },
    list: {
      itemSettings: {
        open: true,
        showCallToAction: false,
        showHoursOperation: false,
        showTicketTypes: false,
        showSpecialInstructions: false,
        showTelephoneNumbers: false,
        showLocationType: false,
      },
    },
  },
  prePopulation: {
    locationSearchOptions: {
      outputCategory: ['STATES', 'CITIES', 'STATIONS'],
    },
    busSearchOptions: {
      geoField: false,
      sortingDetails: [
        {
          field: 'cityName',
          order: 'ASC',
        },
      ],
    },
  },
};
